// import store from "@/state/store";

export default [
    {
        path: "/login",
        name: "login",
        component: () => import("@/views/account/login"),
        meta: {
            title: "Login",
            // beforeResolve(routeTo, routeFrom, next) {
            //     if (store.getters["auth/loggedIn"]) {
            //         next({name: "dashboard"});
            //     } else {
            //         next();
            //     }
            // },
        },
    },
    {
        path: "/esqueceu-senha",
        name: "forgot-password",
        component: () => import("@/views/account/forgot-password.vue"),
        meta: {
            title: "Recuperar Senha",
        },
    },
    {
        path: "/recuperar-senha",
        name: "change-password",
        component: () => import("@/views/account/change-password.vue"),
        meta: {
            title: "Resetar Senha",
        },
    },
    {
        path: "/logout",
        name: "logout",
        component: () => import("@/views/account/logout"),
        meta: {
            title: "Logout",
        },
    },
    {
        path: "/",
        name: "dashboard",
        meta: {
            title: "Dashboard",
            authRequired: true,
        },
        component: () => import("@/views/dashboard/index"),
    },

    {
        path: "/meu-perfil",
        name: "my-profile",
        meta: {
            title: "Meu Perfil",
            authRequired: true,
        },
        component: () => import("@/views/profile/my-profile.vue"),
    },

    {
        path: "/pacientes",
        name: "patients",
        meta: {
            title: "Pacientes",
            authRequired: true,
        },
        component: () => import("@/views/patients/index.vue"),
    },

    {
        path: "/pacientes/:id",
        name: "patients-details",
        meta: {
            title: "Detalhes do Paciente",
            authRequired: true,
        },
        component: () => import("@/views/patients/details.vue"),
    },

    {
        path: "/agendamento",
        name: "scheduling",
        meta: {
            title: "Agendamento",
            authRequired: true,
        },
        component: () => import("@/views/schedule/schedule.vue"),
    },

    {
        path: "/agenda",
        name: "schedule",
        meta: {
            title: "Agenda",
            authRequired: true,
        },
        component: () => import("@/views/schedule/index.vue"),
    },

    {
        path: "/chat",
        name: "chat",
        meta: {
            title: "Chat",
            authRequired: true,
        },
        component: () => import("@/views/chat/index.vue"),
    },

    {
        path: "/evolucoes",
        name: "evolutions",
        meta: {
            title: "Evoluções",
            authRequired: true,
        },
        component: () => import("@/views/evolutions/index.vue"),
    },
];
    